import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import Logo from "@/components/Logo";
import HelpModal from "@/components/HelpModal";
import { useAuth } from "@/lib/auth";
import { HelpCircle, LogOut } from "lucide-react";

export default function Topbar({ variant = "admin" }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [helpOpen, setHelpOpen] = useState(false);

  const link = ({ isActive }) =>
    `text-sm font-medium px-3 py-1.5 rounded-md transition-colors ${
      isActive
        ? "text-white bg-[#1f1f23]"
        : "text-[#9a9aa3] hover:text-white hover:bg-[#17171a]"
    }`;

  return (
    <>
      <header
        className="sticky top-0 z-40 border-b border-[#2a2a30] bg-[#0a0a0b]/85 backdrop-blur-md"
        data-testid="topbar"
      >
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-4">
          <Logo />
          {variant === "admin" && user && (
            <nav className="hidden sm:flex items-center gap-1" data-testid="topbar-nav">
              <NavLink to="/admin" end className={link} data-testid="topbar-link-library">
                Bibliothek
              </NavLink>
              <NavLink to="/admin/editor" className={link} data-testid="topbar-link-editor">
                Editor
              </NavLink>
              <NavLink to="/admin/music" className={link} data-testid="topbar-link-music">
                Musik
              </NavLink>
              <NavLink to="/admin/upload" className={link} data-testid="topbar-link-upload">
                Upload
              </NavLink>
            </nav>
          )}
          <div className="flex items-center gap-2 sm:gap-3">
            <button
              type="button"
              onClick={() => setHelpOpen(true)}
              className="inline-flex items-center justify-center w-9 h-9 rounded-md text-[#9a9aa3] hover:text-white hover:bg-[#17171a] border border-transparent hover:border-[#2a2a30] transition-colors"
              aria-label="Hilfe & Anleitung"
              title="Hilfe & Anleitung"
              data-testid="topbar-help-button"
            >
              <HelpCircle size={18} />
            </button>
            {variant === "admin" && user ? (
              <>
                <span className="hidden md:inline text-xs text-[#9a9aa3]" data-testid="topbar-email">
                  {user.email}
                </span>
                <button
                  onClick={async () => {
                    await logout();
                    navigate("/login");
                  }}
                  className="inline-flex items-center gap-1.5 text-sm text-[#9a9aa3] hover:text-white border border-[#2a2a30] hover:border-[#3a3a40] rounded-md px-2.5 py-1.5 transition-colors"
                  data-testid="topbar-logout-button"
                >
                  <LogOut size={14} />
                  <span className="hidden sm:inline">Logout</span>
                </button>
              </>
            ) : null}
          </div>
        </div>
      </header>
      <HelpModal open={helpOpen} onClose={() => setHelpOpen(false)} />
    </>
  );
}
